import ContentLayout from '@/layouts/content-layout'
import ArticleView from '@/sections/articles/view/article-view'

export default function ArticlesPage() {
  return (
    <ContentLayout title="RFC Talk">
      <ArticleView />
    </ContentLayout>
  )
}
